import { Component, HostListener, Input, OnInit } from '@angular/core';
import { switchMap, tap } from 'rxjs';
import { AnchorModel, Subtree } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-notizia',
  templateUrl: './page-notizia.component.html',
  styleUrls: ['./page-notizia.component.scss']
})
export class PageNotiziaComponent implements OnInit {

  @Input() node: any;
  @Input() isSecondLevelUp: any;
  public block: any;
  public domainWebsite = environment.urlApi;
  public anchorItems: AnchorModel[] = [];
  public idAnchor: string = '';
  public isSpinner: boolean = false;
  public imgPath = '';
  public image_alt = '';
  public levelMenu: Subtree[] = [];
  public titlePage: string = '';
  public relatedNews: any[] = [];
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;


  constructor(
    public nodeService: NodeService,
    public helpersService: HelpersService
  ) { }


  ngOnInit(): void {
    this.isSpinner = true;
    this.titlePage = this.node.title[0].value;
    this.getNode();
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
      if (!boundingCollapse && this.node.type[0].target_id === 'archivio_notizia') {
        boundingCollapse = document.querySelector('.container-page-general')?.getBoundingClientRect();
      }
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }  }

  getNode() {
    if (this.node.type[0].target_id === 'archivio_notizia') {
      this.block = this.node;
    } else {
      this.nodeService.getNodeNews(this.node.nid[0].value, this.node.preview, this.node.langcode[0].value).pipe(
        tap(nodeNews => {
          this.block = nodeNews[0];
          this.setDataFields(this.block);
          this.imgPath = this.domainWebsite + this.helpersService.retrieveImage(this.block.field_immagine, "src");
          this.image_alt = this.helpersService.retrieveImage(this.block.field_immagine, "alt");
        }, err => {
          console.error('err', err);
        }),
        switchMap(nodeNews => this.nodeService.getRelatedViewNews(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, nodeNews[0].field_tassonomia_area_universita, this.node.nid[0].value, this.node.preview))
      ).subscribe(relatedNews => {
        let temp: any[] = [];
        relatedNews.forEach((element: any) => {
          temp.push(this.helpersService.transformResultsExport(element));
        });
        if (temp.length > 6) {
          for (let idx = 0; idx < 6; idx++) {
            this.relatedNews.push(temp[idx]);
          }
        } else {
          this.relatedNews = temp;
        }
      });
    }
  }


  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_dipartimento.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_NOTIZIA.DEPARTMENT',
          value: block.field_tassonomia_dipartimento,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_area_universita.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_FAQ.UNIVERSITY_AREAS',
          value: block.field_tassonomia_area_universita,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_corsi_di_laurea.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_NOTIZIA.DEGREE_COURSE',
          value: block.field_tassonomia_corsi_di_laurea,
          isArray: true
        }
      ]
    }
    if (block.field_tags.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_NOTIZIA.TAG',
          value: block.field_tags,
          isArray: true
        }
      ]
    }
  }
}
